export default function WelcomeScreen({img, label, title, description}) {
    return (
        <div className="welcome-container">
            <h1>Welcome to myEB!</h1>
            <img src={img} />
            <p>{label}</p>
            <h2>{title}</h2>
            <p>{description}</p>
        </div>
    )
}